import { UseQueryResult } from "@tanstack/react-query";
import { Button, Select } from "antd";
import { T_Api_Paginated, T_Api_Success_Res } from "api/api.types";
import { UserSchemaDto } from "dtos/user.dto";
import { ElementRef, useCallback } from "react";
import { TbSearch } from "react-icons/tb";

export function AssignCases({
  onSelect,
  paginatedAllUsers,
}: {
  onSelect: (optionId: string | undefined) => void;
  paginatedAllUsers: UseQueryResult<T_Api_Success_Res<T_Api_Paginated<UserSchemaDto>>>;
}) {
  // const assigneeSearchRef = useRef<ElementRef<typeof Input>>(null);
  const assigneeSearchInput = useCallback<(val: ElementRef<typeof Select>) => void>((assigneeSearchRef) => {
    if (assigneeSearchRef) {
      assigneeSearchRef.focus();
    }
  }, []);

  return (
    <Select
      allowClear
      showSearch
      ref={assigneeSearchInput}
      style={{ width: "200px" }}
      // autoFocus
      prefix={<TbSearch />}
      placeholder="Search users..."
      options={paginatedAllUsers.data?.result.data?.map((el) => ({ value: el._id, label: el.name }))}
      defaultOpen
      filterOption={(searchTerm, option) => {
        return !!option?.label?.toLowerCase()?.includes(searchTerm?.toLowerCase());
      }}
      onSelect={(value) => {
        onSelect(value);
      }}
      dropdownRender={(menu) => {
        return (
          <>
            {menu}
            <Button
              block
              variant="filled"
              color="default"
              onClick={() => onSelect(undefined)}
              style={{
                borderColor: "transparent",
                background: `repeating-linear-gradient(135deg,#f03355 0 10px,#ffa516 0 20px) 0/0%   no-repeat,repeating-linear-gradient(135deg,#ddd    0 10px,#eee    0 20px) 0/100%`,
              }}
            >
              Unassign
            </Button>
          </>
        );
      }}
    />
  );
}
